import { render, staticRenderFns } from "./CustomProductModal.vue?vue&type=template&id=726e53b0&scoped=true&"
import script from "./CustomProductModal.vue?vue&type=script&lang=js&"
export * from "./CustomProductModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductModal.vue?vue&type=style&index=0&id=726e53b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726e53b0",
  null
  
)

export default component.exports